import React from 'react';

import Th from '../Th';

export default function ViewReportTh({
  sortField,
  sortOrder,
  setSortField,
  setSortOrder,
  field,
  title,
  isExport,
}) {
  return (
    <Th
      report
      sortField={isExport ? '' : sortField}
      sortOrder={sortOrder}
      setSortField={setSortField}
      setSortOrder={setSortOrder}
      field={field}
      title={title}
    />
  );
}
